// Shared metadata for the Library type taxonomy.
//
// Both `pages/subpages/Library.tsx` and `components/LibraryBrowserModal.tsx`
// previously kept their own copies of this table. The `equity` color was
// `#0369a1` (out-of-brand sky blue); aligning it on the Tailwind `primary`
// (`#135bec`) keeps the Library visually coherent with Models/Portfolio.

import snakeToPascal from '../../tools';

// The Tailwind theme's `primary` (see tailwind.config.js). Duplicated as a TS
// constant because TYPE_META values are consumed as inline style hex strings,
// not Tailwind classes.
export const PRIMARY_COLOR = '#135bec';

export interface TypeMeta {
    label: string;
    color: string;
    order: number;
}

export const TYPE_META: Record<string, TypeMeta> = {
    company: { label: 'Company', color: '#0f172a', order: 1 },
    equity: { label: 'Equity & Capital', color: PRIMARY_COLOR, order: 2 },
    financial_debt: { label: 'Debt / Loans', color: '#9a3412', order: 3 },
    corporate_taxation: { label: 'Corporate Taxation', color: '#5b21b6', order: 4 },
    fiscality: { label: 'Taxation', color: '#5b21b6', order: 5 },
    asset: { label: 'Asset', color: '#15803d', order: 6 },
    bank_accounts: { label: 'Bank Accounts', color: '#0e7490', order: 7 },
    indexation_references: { label: 'Indexation', color: '#b45309', order: 8 },
    macro_economics: { label: 'Macro Economics', color: '#be185d', order: 9 },
};

export const FALLBACK_COLOR = '#475569';

export function getTypeLabel(type: string): string {
    return TYPE_META[type]?.label ?? snakeToPascal(type);
}

export function getTypeColor(type: string): string {
    return TYPE_META[type]?.color ?? FALLBACK_COLOR;
}

export function sortTypes(types: string[]): string[] {
    return [...types].sort((a, b) => {
        const oa = TYPE_META[a]?.order ?? 999;
        const ob = TYPE_META[b]?.order ?? 999;
        if (oa !== ob) return oa - ob;
        return getTypeLabel(a).localeCompare(getTypeLabel(b));
    });
}
